export default "__VITE_ASSET__a406865a__"